import { render, staticRenderFns } from "./LayoutNavbar.vue?vue&type=template&id=12e4735d"
import script from "./LayoutNavbar.vue?vue&type=script&lang=js"
export * from "./LayoutNavbar.vue?vue&type=script&lang=js"
import style0 from "./LayoutNavbar.vue?vue&type=style&index=0&id=12e4735d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports